<template>
  <div>
    <Card>
      <ui-textarea
        :rows="10"
        placeholder="Placeholder"
      ></ui-textarea>
    </Card>
    <Card>
      <ui-textarea
        :rows="5"
        :readonly="true"
        placeholder="Placeholder"
      ></ui-textarea>
    </Card>
    <Card>
      <ui-textarea
        :rows="5"
        placeholder="Placeholder"
        :disabled="true"
      ></ui-textarea>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
